import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const UPDATE_PAYOUT_AND_SHARE_SENIORITIES = gql`
  mutation _UpdatePayOutsAndSharesSeniority(
    $projectId: ID!
    $shareInputs: [ShareInput!]!
    $payOutInputs: [PayOutInput!]!
  ) {
    _updatePayOutsAndSharesSeniority(
      projectId: $projectId
      shareInputs: $shareInputs
      payOutInputs: $payOutInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

export const CAN_DELETE_SHARE = gql`
  query CanDeleteShare($shareId: ID!) {
    canDeleteShare(shareId: $shareId)
  }
`

export const GET_SHARES = gql`
  query Shares($projectId: ID!) {
    shares(projectId: $projectId) {
      ...Share
    }
  }
  ${fragments.share}
`

export const GET_SHARE = gql`
  query Share($shareId: ID!) {
    share(shareId: $shareId) {
      ...Share
    }
  }
  ${fragments.share}
`

export const _ADD_SHARE = gql`
  mutation _AddShare($projectId: ID!, $input: ShareInput!) {
    _addShare(projectId: $projectId, shareInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_SHARE = gql`
  mutation AddShare($projectId: ID!, $input: ShareInput!) {
    addShare(projectId: $projectId, shareInput: $input) {
      ...Share
    }
  }
  ${fragments.share}
`

export const _SAVE_SHARE = gql`
  mutation _SaveShare($shareId: ID!, $input: ShareInput!) {
    _saveShare(shareId: $shareId, shareInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_SHARE = gql`
  mutation _DeleteShare($shareId: ID!) {
    _deleteShare(shareId: $shareId) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_SHARE,
  saveRemote: _SAVE_SHARE,
  deleteRemote: _DELETE_SHARE,
  saveOp: '_saveShare',
  addOp: '_addShare',
  addsOp: '_addShares',
  deleteOp: '_deleteShare',
}

export const sharesQueries = { ...mutations, getRemote: GET_SHARES }

export const shareQueries = { ...mutations, getRemote: GET_SHARE }
